// A link in the job page's top bar that leaves the app (Photos, Sales risk): opened in Edge from
// the iPad web clip (#615), greyed out with the reason while it can't be opened.
import { OutboundLink } from '@higgins/ui';
import type { ReactNode } from 'react';

interface Props {
  href: string | null;
  /** Why it can't be opened right now; null = it can. */
  blocked: string | null;
  title: string;
  children: ReactNode;
}

export function HeaderOutboundLink({ href, blocked, title, children }: Props) {
  if (blocked || !href) {
    return (
      <span className="flex cursor-default items-center gap-1 text-sm text-slate-400" title={blocked ?? undefined}>
        {children}
      </span>
    );
  }
  return (
    <OutboundLink openIn="edge" href={href} className="flex items-center gap-1 text-sm text-primary" title={title}>
      {children}
    </OutboundLink>
  );
}
